import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";

// Odpięcie złożonego pakietu od sprawy, którą założyła jego wysyłka, USUWA tę sprawę
// (backend: delete_case). Wspólne ostrzeżenie dla strony pakietu i panelu powiązań sprawy.
export function DetachAutoCaseModal({ number, caseName, pending, error, onClose, onConfirm }: {
  number: string;
  caseName: string;
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal open onClose={onClose} title={`Odepnij wniosek ${number} od sprawy`} size="sm">
      <div className="space-y-3 text-sm">
        <div className="border border-red-300 bg-red-50 text-red-800 px-3 py-2">
          Sprawa „{caseName}” została założona <b>automatycznie</b> przy wysyłce wniosku{" "}
          <b>{number}</b>. Odpięcie wniosku <b>usunie tę sprawę</b> razem z pismem wniosku
          w sprawie. Tej operacji nie można cofnąć.
        </div>
        <ul className="list-disc pl-5 space-y-1 text-[var(--color-text-secondary)]">
          <li>Termin KPA tej sprawy przestanie biec, a działki przeliczą status.</li>
          <li>
            Wniosek zostaje <b>złożony</b> — bez sprawy. Możesz go potem podpiąć pod właściwą sprawę
            projektu.
          </li>
          <li>
            Wpis w dzienniku DLC_02 (albo przesyłka w kolejce e-Doręczeń) <b>zostaje</b> — nie jest
            anulowany. Jeśli pismo nie ma wyjść, wycofaj potem wniosek („Wycofaj złożony wniosek”).
          </li>
        </ul>
        {error && <p className="text-xs text-red-600">{error}</p>}
        <div className="flex justify-end gap-2 pt-1">
          <Button size="sm" variant="ghost" onClick={onClose} disabled={pending}>Anuluj</Button>
          <Button size="sm" variant="danger" loading={pending} onClick={onConfirm}>
            Odepnij i usuń sprawę
          </Button>
        </div>
      </div>
    </Modal>
  );
}
